import { ReactElement, useMemo } from 'react';
import { ResolvedDbIdsReturn } from '../../../hooks/order';
import ForgeViewerInteractions from './ForgeViewerInteractions';
import SheetViewerInteractions from './SheetViewerInteractions';
import { SheetsViewerV2Interactions } from 'src/components/viewers/SheetsViewerV2/SheetsViewerV2Interactions';
import { useEnabledSheetViewerModeValue } from 'src/components/viewers/common/hooks/useEnabledSheetViewerModeValue';
import { ViewerMode } from 'src/components/common/viewer-mode';
import { useActiveModels } from 'src/hooks/active-models';
import { useProjectHistory } from 'src/components/project/project-history/hooks/useProjectHistory';

interface ViewerInteractionsProps {
  resolvedDbIds: ResolvedDbIdsReturn;
  projectId: string;
  readOnly?: boolean;
}

export default function ViewerInteractions({
  resolvedDbIds,
  projectId,
  readOnly,
}: ViewerInteractionsProps): ReactElement {
  const { sheetsViewerMode } = useEnabledSheetViewerModeValue();
  const { activeModels } = useActiveModels(projectId);
  const { eventsActiveModels } = useProjectHistory();

  // const models = useMemo(() => activeModels ?? [], [activeModels]);
  const models = useMemo(() => {
    if (eventsActiveModels) {
      return eventsActiveModels;
    }
    return activeModels ?? [];
  }, [activeModels, eventsActiveModels]);

  return (
    <>
      {/* Render both to avoid having to lift all of the state in ForgeViewerInteractions */}
      {sheetsViewerMode === ViewerMode.SheetsV2 && (
        <SheetsViewerV2Interactions />
      )}
      {sheetsViewerMode === ViewerMode.Sheets && (
        <SheetViewerInteractions projectId={projectId} readOnly={readOnly} />
      )}
      <ForgeViewerInteractions models={models} resolvedDbIds={resolvedDbIds} />
    </>
  );
}
